import { Form } from 'react-bootstrap';

const Veiculo = props => {
  return (
    <>
      <Form.Group controlId="formSubCategoria" className="mt-4">
        <Form.Label>*Subcategoria:</Form.Label>
        <Form.Select
          className="border border-secondary"
          required
          name="formSubCategoria"
          onChange={e => props.handleSubcategoria(e)}
        >
          <option value="">Selecione a Subcategoria</option>
            {props.getCategorias?.find(categoria => categoria.id === 8)?.subcategoria.map(item => (
              <option key={item.nome} value={item.nome}>{item.nome}</option>
            ))}
          {/* {props.unidade.includes('Diretoria') ?
            props.getCategorias?.find(categoria => categoria.id === 8)?.subcategoria.map(item => (
              <option key={item.nome} value={item.nome}>{item.nome}</option>
            )) :
            props.getCategorias?.find(categoria => categoria.id === 7)?.subcategoria.map(item => (
            <option key={item.nome} value={item.nome}>{item.nome}</option>
          ))} */}
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default Veiculo;
